'use client';
import { Box, Grid, ImageList, SxProps } from '@mui/material';
import { PropsWithChildren } from 'react';
import useIsMobile from '../../../../utils/useIsMobile';

type Props = {
  sx?: SxProps;
  columns: number;
  variant: 'static' | 'masonry';
  initIsMobile?: boolean;
};
const ListContainer = ({
  variant,
  children,
  initIsMobile,
  sx,
  columns,
}: PropsWithChildren<Props>) => {
  const isMobile = useIsMobile(initIsMobile);
  if (variant === 'static') {
    return (
      <Box
        sx={{ mx: 'auto !important', ...sx }}
        className={'tb-cards-inner-container'}
      >
        <Grid
          container
          spacing={3}
          sx={{ alignItems: { xs: 'start', md: 'stretch' } }}
        >
          {children}
        </Grid>
      </Box>
    );
  }
  if (variant === 'masonry') {
    return (
      <ImageList
        className={'tb-cards-inner-container'}
        variant="masonry"
        cols={isMobile ? 1 : columns}
        gap={20}
        sx={{ my: 0, ...sx }}
      >
        {children!}
      </ImageList>
    );
  }
};

export default ListContainer;
